/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A reusable project-scoped custom signal.
 */
export type SigintSignal = {
  /**
   * Optional criteria describing when this signal applies
   */
  classifierCriteria?: string | undefined;
  /**
   * Creation time
   */
  createdAt: Date;
  /**
   * Optional author-facing description
   */
  description?: string | undefined;
  /**
   * Signal ID
   */
  id: string;
  /**
   * Display name
   */
  name: string;
  /**
   * Owning project ID
   */
  projectId: string;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  slug: string;
  /**
   * Last update time
   */
  updatedAt: Date;
};

/** @internal */
export const SigintSignal$inboundSchema: z.ZodMiniType<SigintSignal, unknown> =
  z.pipe(
    z.object({
      classifier_criteria: z.optional(z.string()),
      created_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      description: z.optional(z.string()),
      id: z.string(),
      name: z.string(),
      project_id: z.string(),
      slug: z.string(),
      updated_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        "classifier_criteria": "classifierCriteria",
        "created_at": "createdAt",
        "project_id": "projectId",
        "updated_at": "updatedAt",
      });
    }),
  );

export function sigintSignalFromJSON(
  jsonString: string,
): SafeParseResult<SigintSignal, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SigintSignal$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SigintSignal' from JSON`,
  );
}
